import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

type ImageViewerProps = {
  isOpen: boolean;
  imageUrl: string;
  toggle: () => void;
};

const ImageViewer: React.FC<ImageViewerProps> = ({ isOpen, imageUrl, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalBody className="d-flex justify-content-center align-items-center" style={{ backgroundColor: "#000", padding: 0 , width:"100%", height:"450px" ,  borderRadius:"4px" }}>
        {/* Close Button */}
        <Button
          close
          onClick={toggle}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "#fff",
            zIndex: 1000,
          }}
        >
          &times;
        </Button>

        {/* Zoomable Image */}
        <TransformWrapper>
          <TransformComponent>
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width:"auto",
                maxWidth: "100%",
                height:"345px",
                // margin: "auto",
                display: "block",
              }}
            />
          </TransformComponent>
        </TransformWrapper>
      </ModalBody>
    </Modal>
  );
};

export default ImageViewer;
